module.exports = __webpack_public_path__ + "media/images/s03_02_pt-b9bb5ab1d5d099b9347b638cd91732a1.svg";